module.exports = __webpack_public_path__ + "static/img/p4.200d994.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p4.png
// module id = pIfk
// module chunks = 1